<script>
	import Select from "svelte-select";

	export let items = [];
	export let error = false;
	export let errorText = "";
	export let placeholder = "";
	export let value = "";
	export let containerClasses = "";
	export let onInput = () => {};
	export let onChange = () => {};
	export let handleClear = () => {};
	export let onSelect = (e) => {};
	export let loadOptions = undefined;
	export let errorBorder = false;
	export let isClearable = true;
	export let isSearchable = true;
	export let chevron = false;
	export let isMulti = false;
	export let isCreatable = false;
	export let label = "";
	export let disabled = false;
	export let showSearchIcon = false;
	export let Item = undefined;
	export let Selection = undefined;
	export let filterText = "";

	let listOpen = false;
	$: hasValue = isMulti ? value?.length > 0 : !!value;
	$: showChevron = chevron && !(hasValue && isClearable && !disabled);
	$: searchIconVisible = showSearchIcon && !isMulti;

	const customCreateOptionLabel = (option, filterText) => {
		return filterText;
	};
</script>

<div
	class="dropdown-chevron-wrapper"
	class:search-icon-visible={searchIconVisible}
	class:own-chevron={chevron}
>
	<Select
		bind:listOpen
		{isCreatable}
		{isMulti}
		{...Item ? { Item } : {}}
		{...Selection ? { Selection } : {}}
		type="text"
		bind:value
		bind:filterText
		{items}
		{loadOptions}
		hasError={error}
		containerClasses={`form-select getgo select ${error ? "danger" : ""} ${
			isMulti ? "min-h search-icon" : ""
		} ` + containerClasses}
		{placeholder}
		inputAttributes={{ "aria-label": label || placeholder }}
		on:input={onInput}
		onChange={onInput}
		{handleClear}
		{isClearable}
		{isSearchable}
		isDisabled={disabled}
		on:select={(e) => {
			if (
				!isCreatable &&
				e.detail &&
				e.detail.value === e.detail.label.toLowerCase()
			) {
				return;
			}
			onSelect(e);
		}}
		inputStyles={`color: var(--fds-on-surface-variant); padding: 0 ${
			containerClasses ? "32px" : isCreatable ? "2px" : "12px"
		}; height: auto;`}
		noOptionsMessage={"No result"}
		on:change={onInput}
		getOptionLabel={isCreatable ? customCreateOptionLabel : undefined}
	/>
	{#if searchIconVisible}
		<span class="dropdown-search-icon" />
	{/if}
	{#if showChevron}
		<span class="dropdown-chevron" />
	{/if}
</div>

{#if error}
	<small class="error-text">{errorText}</small>
{/if}

<style>
	:global(.svelte-17l1npl)::placeholder {
		font-family: "DM Sans", system-ui !important;
	}

	:global(.svelte-14r22mt)::placeholder {
		color: var(--fds-on-surface-variant) !important;
		font-size: 1.1em !important;
	}

	.error-border {
		border: 1px solid var(--fds-danger) !important;
	}

	.dropdown-chevron-wrapper {
		position: relative;
		width: 100%;
	}

	.search-logo {
		padding-left: 34px;
	}

	:global(.selectContainer.svelte-17l1npl input.svelte-17l1npl) {
		padding: 0 32px !important;
	}
	:global(.selectContainer.svelte-17l1npl input.svelte-17l1npl::placeholder) {
		color: var(--fds-on-surface-variant) !important;
	}
	:global(.selectContainer.focused.svelte-17l1npl.svelte-17l1npl) {
		border: 1.5px solid var(--fds-primary) !important;
	}
	.dropdown-chevron-wrapper {
		position: relative;
		width: 100%;
	}

	.dropdown-search-icon {
		pointer-events: none;
		position: absolute;
		left: 12px;
		top: 50%;
		transform: translateY(-50%);
		width: 16px;
		height: 16px;
		z-index: 1;
		background: url("/assets/icon-magnifier.svg") no-repeat center / 16px
			16px;
	}

	.own-chevron :global(.indicator) {
		display: none;
	}

	.search-icon-visible :global(input) {
		padding-left: 36px !important;
	}

	.search-icon-visible :global(.selectedItem) {
		padding-left: 20px !important;
	}

	.dropdown-chevron {
		pointer-events: none;
		position: absolute;
		right: 16px;
		top: 50%;
		transform: translateY(-50%);
		width: 20px;
		height: 20px;
		background-image: url("/assets/icon-chevron-down.png");
		background-repeat: no-repeat;
		background-size: 20px 20px;
	}

	:global(.multiSelectItem.svelte-ymdjdm.svelte-ymdjdm) {
		margin: 7px !important;
		border-radius: 8px !important;
		background-color: var(--fds-surface-container-high) !important;
	}

	:global(.multiSelectItem.svelte-ymdjdm.svelte-ymdjdm:hover) {
		color: inherit !important;
	}

	:global(.min-h) {
		min-height: 48px !important;
		height: auto !important;
	}
</style>
